import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AlertContextProvider } from "./components/CustomFunctions/AlertContext";
import { AuthProvider } from "./contexts/AuthContext";

// redux
import store from "./redux/store";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AlertContextProvider>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </AlertContextProvider>
);
